import axios from 'axios';
import { StateType } from '@pok/minter-sdk';
import { wait } from '@pok/lang';
export const listCertificates = async (certsIndexApiRoot, authToken, input, retryConfig) => {
    const results = await doListCertificates(certsIndexApiRoot, authToken, input);
    const outdatedResults = results.results.filter((it) => it.outdated);
    if (!retryConfig)
        return results;
    if (outdatedResults.length > 0 && retryConfig.maxRetriesWhenOutdated > 0) {
        retryConfig.onOutdatedResults?.(outdatedResults);
        return wait(retryConfig.retryDelay).then(() => listCertificates(certsIndexApiRoot, authToken, input, {
            ...retryConfig,
            maxRetriesWhenOutdated: retryConfig.maxRetriesWhenOutdated - 1,
        }));
    }
    return results;
};
const doListCertificates = async (certsIndexApiRoot, authToken, input) => axios
    .get(`${certsIndexApiRoot}/certificate/list`, {
    params: {
        [ListCertificatesQsp.id]: input.filters.id?.join(','),
        [ListCertificatesQsp.wallet]: input.filters.wallet,
        [ListCertificatesQsp.size]: input.size,
        [ListCertificatesQsp.last]: input.last,
        [ListCertificatesQsp.previous]: input.previous,
        [ListCertificatesQsp.identification]: input.filters.identification,
        [ListCertificatesQsp.email]: input.filters.email,
        [ListCertificatesQsp.processing]: input.filters.processing,
        [ListCertificatesQsp.fromDate]: input.filters.fromDate,
        [ListCertificatesQsp.toDate]: input.filters.toDate,
        [ListCertificatesQsp.approvalRequestedFromDate]: input.filters.approvalRequestedFromDate,
        [ListCertificatesQsp.approvalRequestedToDate]: input.filters.approvalRequestedToDate,
        [ListCertificatesQsp.customPageId]: input.filters.customPageId,
        [ListCertificatesQsp.currentStateIn]: input.filters.currentStateIn?.join(','),
        [ListCertificatesQsp.requiringSignatureOf]: input.filters.requiringSignatureOf,
        [ListCertificatesQsp.tag]: input.filters.tag,
    },
    headers: { authorization: authToken.value() },
})
    .then((output) => output.data);
export const countCertificates = async (certsIndexApiRoot, authToken, filters) => axios
    .get(`${certsIndexApiRoot}/certificate/count`, {
    params: {
        [CountCertificatesQsp.wallet]: filters.wallet,
        [CountCertificatesQsp.identification]: filters.identification,
        [CountCertificatesQsp.email]: filters.email,
        [CountCertificatesQsp.processing]: filters.processing,
        [CountCertificatesQsp.fromDate]: filters.fromDate,
        [CountCertificatesQsp.toDate]: filters.toDate,
        [CountCertificatesQsp.approvalRequestedFromDate]: filters.approvalRequestedFromDate,
        [CountCertificatesQsp.approvalRequestedToDate]: filters.approvalRequestedToDate,
        [CountCertificatesQsp.customPageId]: filters.customPageId,
        [CountCertificatesQsp.currentStateIn]: filters.currentStateIn?.join(','),
        [CountCertificatesQsp.requiringSignatureOf]: filters.requiringSignatureOf,
        [CountCertificatesQsp.tag]: filters.tag,
    },
    headers: { authorization: authToken.value() },
})
    .then((output) => output.data);
export const batchDownload = async (certsIndexApiRoot, //
input, authToken) => axios
    .post(`${certsIndexApiRoot}/certificate/download`, input, {
    headers: { Authorization: authToken.value() },
})
    .then((output) => output.data);
export const minterPendingApprovalCertificates = async (minterApiRoot, id, token) => {
    return axios
        .post(`${minterApiRoot}/pendingApprovalCertificates`, {
        token: `${id}:${token}`,
    })
        .then((output) => output.data);
};
export const certsIndexPendingApprovalCertificates = async (certsIndexApiRoot, id, token) => {
    return axios
        .get(`${certsIndexApiRoot}/certificate/list?token=${id}:${token}&currentStateIn=${StateType.APPROVAL_REQUESTED}`, { headers: { Authorization: 'Anonymous view' } })
        .then((output) => output.data);
};
export var ApprovalRequestType;
(function (ApprovalRequestType) {
    ApprovalRequestType["AUTOMATIC"] = "AUTOMATIC";
    ApprovalRequestType["MANUAL"] = "MANUAL";
})(ApprovalRequestType || (ApprovalRequestType = {}));
export var CertificatesOrderBy;
(function (CertificatesOrderBy) {
    CertificatesOrderBy[CertificatesOrderBy["CREATED_AT_DESC"] = 0] = "CREATED_AT_DESC";
})(CertificatesOrderBy || (CertificatesOrderBy = {}));
export const ListCertificatesQsp = {
    size: 'size',
    previous: 'previous',
    last: 'last',
    identification: 'identification',
    fromDate: 'fromDate',
    toDate: 'toDate',
    approvalRequestedFromDate: 'approvalRequestedFromDate',
    approvalRequestedToDate: 'approvalRequestedToDate',
    processing: 'processing',
    wallet: 'wallet',
    email: 'email',
    customPageId: 'customPageId',
    currentStateIn: 'currentStateIn',
    tag: 'tag',
    requiringSignatureOf: 'requiringSignatureOf',
    id: 'id',
    orderBy: 'orderBy',
    token: 'token',
};
export const CountCertificatesQsp = {
    identification: 'identification',
    fromDate: 'fromDate',
    toDate: 'toDate',
    approvalRequestedFromDate: 'approvalRequestedFromDate',
    approvalRequestedToDate: 'approvalRequestedToDate',
    processing: 'processing',
    wallet: 'wallet',
    email: 'email',
    customPageId: 'customPageId',
    currentStateIn: 'currentStateIn',
    tag: 'tag',
    requiringSignatureOf: 'requiringSignatureOf',
};
export const emptyFilters = (filters) => Object.values(filters).every((value) => value === undefined);
//# sourceMappingURL=index.js.map